import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export async function submitContact(payload) {
  const res = await apiClient.post("/contact", payload);
  return res.data;
}
